import { useTranslation } from 'react-i18next';
import { Card } from 'semantic-ui-react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import styles from '../styles/Activity.module.scss';
import ActionRequired from './ActionRequired';
import { ActivityInitialDataResponse } from '@components/Activity/types/ActivityInitialDataResponse';
import { ActionState } from '@components/Activity/types/ActionState';

type Props = {
  actionState: ActionState;
  initialData?: ActivityInitialDataResponse;
  disabled?: boolean;
};

const TEXT = '#1f2328';
const TEXT_MUTED = '#8b95a3';
const BORDER = '#e6e8ec';

const ActionFormContainer = ({ actionState, initialData, disabled }: Props) => {
  const { t } = useTranslation();
  const {
    actionCard,
    setActionCard,
    count,
    setCount,
    actionCardContent,
    setActionCardContent,
    actionCardContentList,
    setActionCardContentList,
  } = actionState;

  const total = actionCardContentList?.length ?? 0;

  return (
    <div className={styles.component}>
      <Card className={styles.card}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: 2,
            px: { xs: 1.5, sm: 2 },
            pt: 2,
            pb: 1.5,
            borderBottom: `1px solid ${BORDER}`,
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: 22, md: 26 },
              fontWeight: 700,
              letterSpacing: '-0.015em',
              color: TEXT,
              lineHeight: 1.15,
              m: 0,
            }}
          >
            {t('action.form.details.page.container.title')}
          </Typography>
          {total > 0 && (
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: TEXT_MUTED,
                flexShrink: 0,
              }}
            >
              {t(total === 1 ? 'action.form.count.one' : 'action.form.count.other', { count: total })}
            </Typography>
          )}
        </Box>
        <Box sx={{ px: { xs: 1.5, sm: 2 }, py: 1.5 }}>
          <ActionRequired
            actionCard={actionCard}
            setActionCard={setActionCard}
            count={count}
            setCount={setCount}
            initialData={initialData}
            actionCardContent={actionCardContent}
            setActionCardContent={setActionCardContent}
            actionCardContentList={actionCardContentList}
            setActionCardContentList={setActionCardContentList}
            disabled={disabled}
          />
        </Box>
      </Card>
    </div>
  );
};

export default ActionFormContainer;
